import { qs } from '@fluorescent/dom';

const selectors = {
  productSku: '[data-product-sku]',
};

export default function (container, variant) {
  const skuElement = qs(selectors.productSku, container);

  if (!skuElement) return;

  if (!variant || !variant.sku) {
    skuElement.innerText = '';
    return;
  }

  skuElement.innerText = variant.sku;
}
